export default "__VITE_ASSET__C043wUOo__"